<aside [ngClass]="{ open }" class="sidebar" aria-label="Primary navigation">
  <ul>

    <!-- ── Overview ── -->
    <li class="section-label">Overview</li>
    <li *ngIf="showMainDashboard">
      <a (click)="navigate('dashboard')" [class.active-link]="activeLink === 'dashboard'" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.557 2.75H4.682A1.93 1.93 0 0 0 2.75 4.682v3.875a1.94 1.94 0 0 0 1.932 1.942h3.875a1.94 1.94 0 0 0 1.942-1.942V4.682A1.94 1.94 0 0 0 8.557 2.75m10.761 0h-3.875a1.94 1.94 0 0 0-1.942 1.932v3.875a1.943 1.943 0 0 0 1.942 1.942h3.875a1.94 1.94 0 0 0 1.932-1.942V4.682a1.93 1.93 0 0 0-1.932-1.932m0 10.75h-3.875a1.94 1.94 0 0 0-1.942 1.933v3.875a1.94 1.94 0 0 0 1.942 1.942h3.875a1.94 1.94 0 0 0 1.932-1.942v-3.875a1.93 1.93 0 0 0-1.932-1.932M8.557 13.5H4.682a1.943 1.943 0 0 0-1.932 1.943v3.875a1.93 1.93 0 0 0 1.932 1.932h3.875a1.94 1.94 0 0 0 1.942-1.932v-3.875a1.94 1.94 0 0 0-1.942-1.942"/></svg>
        Dashboard
      </a>
    </li>

    <li class="sidebar-divider" *ngIf="showMainDashboard"></li>

    <!-- ── Vehicle Management ── -->
    <li class="section-label" *ngIf="showCoreOps">Vehicle Management</li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('vehicle')" [class.active-link]="['vehicle', 'add-vehicle', 'vehicle/bulk'].includes(activeLink)" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2" d="M1 2h22v7H1zm3 10h1v1H4zm0-7h1v1H4zm0 14h1v1H4zm-3-3h22v7H1zm0-7h22v7H1z"/></svg>
        Vehicle Database
      </a>
    </li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('vehicle-monitoring')"
         [class.active-link]="['vehicle-monitoring', 'vehicle-alert-rules', 'add-vehicle-monitoring', 'add-vehicle-alert', 'edit-vehicle-monitoring', 'edit-vehicle-alert'].includes(activeLink)"
         (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                d="M9 17H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4m6 12h4a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4M9 7h6M9 11h6M9 15h2"/>
        </svg>
        Vehicle Monitoring
      </a>
    </li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('blacked-vehicle')" [class.active-link]="['blacked-vehicle', 'add-vehicle-black-list'].includes(activeLink)" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M6 6l12 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        Blacklisted Vehicles
      </a>
    </li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('view-hotlist')" [class.active-link]="['view-hotlist', 'add-hotlist'].includes(activeLink)" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M13.09 14.024a4.61 4.61 0 0 0-2.377-4.279a.6.6 0 0 0-.809.201l-.964 1.543l-.802-.97a.5.5 0 0 0-.734-.039a4.6 4.6 0 0 0-1.395 3.544a3.54 3.54 0 0 0 7.08 0m-5.353-2.42l-.062.082a3.6 3.6 0 0 0-.669 2.26l.003.059a2.54 2.54 0 0 0 5.08 0l.003-.058c.007-.065.163-1.853-1.473-3.069l-.081-.059l-1.044 1.67a.6.6 0 0 1-.971.064z"/><path d="M8.974 2.09a.599.599 0 0 1 1.017-.304c.194.198.567.59.946 1.042c.372.443.778.976 1.012 1.451c.228.464.47 1.064.661 1.565l.889-1.48a.6.6 0 0 1 .98-.07c1.263 1.56 1.892 3.231 2.205 4.507c.157.639.236 1.182.276 1.568a8 8 0 0 1 .04.58V11c0 3.897-3.091 7.07-7.002 7.07S3 14.896 3 10.998c0-1.073.507-3.6 2.007-5.672a.6.6 0 0 1 .998.043L7.02 7.06c.308-.482.72-1.159 1.033-1.784c.45-.9.807-2.597.921-3.185m.823.95c-.181.8-.48 1.942-.85 2.684c-.492.983-1.201 2.063-1.445 2.426a.6.6 0 0 1-1.01-.026l-1.02-1.698C4.376 8.2 4 10.193 4 11c0 3.358 2.654 6.068 5.998 6.068S16 14.358 16 11v-.028l-.004-.1a8 8 0 0 0-.031-.401a11 11 0 0 0-.252-1.431a10.7 10.7 0 0 0-1.66-3.655l-1.014 1.688a.601.601 0 0 1-1.081-.108c-.162-.454-.559-1.538-.907-2.244c-.177-.361-.516-.817-.88-1.25a17 17 0 0 0-.374-.43"/></g></svg>
          Hotlisted Vehicles
      </a>
    </li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('alert')" [class.active-link]="['alert'].includes(activeLink)" (click)="onLinkClick()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                    d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0a3 3 0 0 1-6 0"/>
          </svg>
        Alerts
      </a>
    </li>

    <li class="sidebar-divider" *ngIf="showCoreOps && visitorManagementVisible"></li>

    <!-- ── Visitor Management collapsible ── -->
    <ng-container *ngIf="visitorManagementVisible">
      <li class="section-label">Visitors</li>
      <li class="collapsible-parent">
        <a class="collapse-toggle" (click)="toggleVisitors()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4" fill="none" stroke="currentColor" stroke-width="1.5"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          Visitor Management
          <span class="chevron" [class.open]="visitorsOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m9 18 6-6-6-6"/></svg>
          </span>
        </a>
      </li>
      <ng-container *ngIf="visitorsOpen">
        <li class="submenu-item">
          <a (click)="navigate('visitor-management/select-register')" [class.active-link]="activeLink === 'visitor-submit'" (click)="onLinkClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>
            Submit Entry
          </a>
        </li>
        <li class="submenu-item" *ngIf="isAdmin">
          <a (click)="navigate('visitor-management/registers')" [class.active-link]="activeLink === 'visitor-registers'" (click)="onLinkClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>
            Registers
          </a>
        </li>
        <li class="submenu-item" *ngIf="isAdmin">
          <a (click)="navigate('visitor-management/clusters')" [class.active-link]="activeLink === 'visitor-clusters'" (click)="onLinkClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
            Clusters
          </a>
        </li>
        <li class="submenu-item" *ngIf="isAdmin">
          <a (click)="navigate('visitor-management/entries')" [class.active-link]="activeLink === 'visitor-entries'" (click)="onLinkClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18"/></svg>
            Entries
          </a>
        </li>
      </ng-container>
    </ng-container>

    <li class="sidebar-divider" *ngIf="showCoreOps"></li>

    <!-- ── Insights ── -->
    <li class="section-label" *ngIf="showCoreOps">Insights</li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('track')" [class.active-link]="activeLink === 'track'" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M10.29 19H6v1c0 .5-.4 1-1 1H4c-.5 0-1-.5-1-1v-8l2.1-6c.2-.6.7-1 1.4-1h11c.6 0 1.2.4 1.4 1l2.01 5.74a6.54 6.54 0 0 0-2.73-1.79L17.1 7H6.8l-1 3h8.11c-1.12.4-2.1 1.1-2.83 2H5v5h4.68c.1.71.32 1.38.61 2M6 14.5c0 .8.7 1.5 1.5 1.5S9 15.3 9 14.5S8.3 13 7.5 13S6 13.7 6 14.5m10.11-2.89c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5c.89 0 1.69-.25 2.39-.68L21.61 23L23 21.61l-3.08-3.11c.44-.68.69-1.5.69-2.39c0-2.5-2-4.5-4.5-4.5m0 2c1.39 0 2.5 1.12 2.5 2.5s-1.11 2.5-2.5 2.5s-2.5-1.11-2.5-2.5s1.12-2.5 2.5-2.5"/></svg>
        Track Vehicle
      </a>
    </li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('reports')" [class.active-link]="['reports'].includes(activeLink)" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M12 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m-5 6a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m10-2a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m2-8H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z"/></svg>
        Reports
      </a>
    </li>
    <li *ngIf="showCoreOps">
      <a (click)="navigate('analytics')" [class.active-link]="['analytics'].includes(activeLink)" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32"><path fill="currentColor" d="M4 2H2v26a2 2 0 0 0 2 2h26v-2H4Z"/><path fill="currentColor" d="M30 9h-7v2h3.59L19 18.59l-4.29-4.3a1 1 0 0 0-1.42 0L6 21.59L7.41 23L14 16.41l4.29 4.3a1 1 0 0 0 1.42 0l8.29-8.3V16h2Z"/></svg>
        Analytics
      </a>
    </li>

    <li class="sidebar-divider" *ngIf="showCoreOps"></li>

      <!-- ── Vision (platform diagnostics + configuration) ── -->
      <li class="section-label" *ngIf="canAccessVisionOperations || canAccessVisionConfiguration">Vision</li>
      <li *ngIf="canAccessVisionOperations">
          <a (click)="navigate('operations')" [class.active-link]="activeLink === 'operations'" (click)="onLinkClick()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8"
                        d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/>
                  <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="1.8"/>
              </svg>
              Vision Operations
          </a>
      </li>
      <li *ngIf="canAccessVisionConfiguration">
          <a (click)="navigate('vision-configuration')"
             [class.active-link]="activeLink === 'vision-configuration'"
             (click)="onLinkClick()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8"
                        d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/>
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/>
              </svg>
              Vision Configuration
          </a>
      </li>
      <li *ngIf="canAccessDeviceHealth">
          <a (click)="navigate('device-health')"
             [class.active-link]="activeLink === 'device-health'"
             (click)="onLinkClick()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8"
                        d="M22 12h-4l-3 9L9 3l-3 9H2"/>
              </svg>
              Device Health
          </a>
      </li>

      <li class="sidebar-divider"
          *ngIf="canAccessVisionOperations || canAccessVisionConfiguration || canAccessDeviceHealth"></li>

      <!-- ── Admin ── -->
    <li class="section-label">{{role | uppercase}}</li>
    <li>
      <a (click)="navigate('organization')" [class.active-link]="['organization', 'signup'].includes(activeLink)" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256"><path fill="currentColor" d="M125.18 156.94a64 64 0 1 0-82.36 0a100.23 100.23 0 0 0-39.49 32a12 12 0 0 0 19.35 14.2a76 76 0 0 1 122.64 0a12 12 0 0 0 19.36-14.2a100.33 100.33 0 0 0-39.5-32M44 108a40 40 0 1 1 40 40a40 40 0 0 1-40-40m206.1 97.67a12 12 0 0 1-16.78-2.57A76.31 76.31 0 0 0 172 172a12 12 0 0 1 0-24a40 40 0 1 0-10.3-78.67a12 12 0 1 1-6.16-23.19a64 64 0 0 1 57.64 110.8a100.23 100.23 0 0 1 39.49 32a12 12 0 0 1-2.57 16.73"/></svg>
        Organization
      </a>
    </li>
    <li *ngIf="canAccessSubscriptions">
      <a (click)="navigate('subscriptions')" [class.active-link]="['subscriptions'].includes(activeLink)" (click)="onLinkClick()">
        <!-- outline credit-card icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2" ry="2" fill="none" stroke="currentColor" stroke-width="1.8"/><line x1="1" y1="10" x2="23" y2="10" stroke="currentColor" stroke-width="1.8"/></svg>
        Subscriptions
      </a>
    </li>
      <li *ngIf="isSuperUser">
          <a (click)="navigate('admin/partners')" [class.active-link]="['partners'].includes(activeLink)"
             (click)="onLinkClick()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M12 2v6m0 8v6m10-10h-6M8 12H2"/>
                  <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="1.8"/>
                  <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/>
              </svg>
              Technology Partners
          </a>
      </li>
      <li *ngIf="isSuperUser">
          <a (click)="navigate('admin/api-keys')" [class.active-link]="['api-keys'].includes(activeLink)"
             (click)="onLinkClick()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8"
                        d="M7 14a5 5 0 1 1 0-10h6a5 5 0 0 1 0 10H7zm0 0H5a3 3 0 0 0 0 6h8a3 3 0 0 0 0-6h-2"/>
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.8" d="M10 9h5M10 9V7m0 2v2"/>
              </svg>
              API Keys
          </a>
      </li>
    <ng-container *ngIf="canAccessLeadManagement">
      <li>
        <a (click)="navigate('admin/sales-installation-partners')" [class.active-link]="['sales-installation-partners'].includes(activeLink)" (click)="onLinkClick()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4" fill="none" stroke="currentColor" stroke-width="1.8"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          Sales & Installation Partners
        </a>
      </li>
      <li class="collapsible-parent">
        <a class="collapse-toggle" (click)="toggleLeadManagement()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M4 19.5V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12.5M8 5V3m8 2V3M4 10h16M8 14h3m-3 4h8"/></svg>
          Lead Management
          <span class="chevron" [class.open]="leadManagementOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m9 18 6-6-6-6"/></svg>
          </span>
        </a>
      </li>
      <ng-container *ngIf="leadManagementOpen">
        <li class="submenu-item">
          <a (click)="navigate('lead-management/leads')" [class.active-link]="activeLink === 'lead-list'" (click)="onLinkClick()">Leads</a>
        </li>
        <li class="submenu-item">
          <a (click)="navigate('lead-management/follow-ups')" [class.active-link]="activeLink === 'lead-follow-ups'" (click)="onLinkClick()">Follow-ups</a>
        </li>
        <li class="submenu-item">
          <a (click)="navigate('lead-management/demo-schedule')" [class.active-link]="activeLink === 'lead-demo-schedule'" (click)="onLinkClick()">Demo Schedule</a>
        </li>
      </ng-container>
    </ng-container>
    <li *ngIf="isSuperUser">
        <a (click)="navigate('admin/initial-occupancy-upload')"
           [class.active-link]="['initial-occupancy-upload'].includes(activeLink)" (click)="onLinkClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.8" d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16"/>
            </svg>
            Initial Occupancy Upload
        </a>
    </li>
      <li *ngIf="isSuperUser">
        <a (click)="navigate('admin/contact-us-requests')"
           [class.active-link]="['contact-us-requests'].includes(activeLink)" (click)="onLinkClick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.8"
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6" fill="none" stroke="currentColor" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="1.8"/>
            </svg>
            Customer Enquiries
      </a>
    </li>
    <li *ngIf="isSuperUser">
      <a (click)="navigate('login-activity')" [class.active-link]="['login-activity'].includes(activeLink)" (click)="onLinkClick()">
        <!-- outline clock icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.8"/><polyline points="12 6 12 12 16 14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/></svg>
        Login Activity
      </a>
    </li>
    <li *ngIf="isSuperUser">
      <a (click)="navigate('logs')" [class.active-link]="['logs'].includes(activeLink)" (click)="onLinkClick()">
        <!-- outline file-text icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/><line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-linecap="round" stroke-width="1.8"/><line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="1.8"/><polyline points="10 9 9 9 8 9" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.8"/></svg>
        Logs
      </a>
    </li>

    <li class="sidebar-divider"></li>

      <!-- ── Support ── customer organizations only ── -->
      <li *ngIf="canAccessHelpSupport">
      <a (click)="navigate('contact-us')" [class.active-link]="activeLink === 'contact-us'" (click)="onLinkClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.8"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2.5"/></svg>
        Help & Support
      </a>
    </li>

  </ul>
</aside>
